/* Global imports */
import React from 'react'

/* Local imports */
import Text from 'Components/Text'
import Separator from 'Components/Separator'
import Spacer from 'Components/Spacer'

/* Component definition */
const Impressum = () => {
  return (
    <div style={{ padding: '0px 8px'}}>
      <Text as="h4">mainMenu.impressum</Text>
      <Separator minWidth={0}/>
      <Text as="h5" notr>Verantwortlich für den Inhalt</Text>
      <Text as="h6" notr>Pro Akustik Hörakustiker GmbH & Co KG</Text>
      <Text as="p" notr>
        <br/>
        Königstraße 52<br/>
        30175 Hannover<br/>
        Telefon 0511-388198 0<br/>
        Telefax 0511-388198 15<br/>
        info@proakustik.de
        <br/><br/>
        Geschäftsführer: Jan H.Wrocklage<br/>
        Rg. Hannover HRA 25545<br/>
        Umst.ID: DE 186186375
        <br/><br/>
      </Text>
      <Text as="h6" notr>Haftung für Inhalte</Text>
      <Text as="p" notr>
        <br/>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        <br/>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        <br/><br/>
      </Text>
      <Text as="h6" notr>Haftung für Links</Text>
      <Text as="p" notr>
        <br/>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        <br/>
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        <br/><br/>
      </Text>
      <Text as="h6" notr>Urheberrecht</Text>
      <Text as="p" notr>
        <br/>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        <br/>
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        <br/>
      </Text>
      <Spacer height="32px"/>
    </div>
  )
}

/* PropTypes */
Impressum.propTypes = {}

Impressum.defaultProps = {}

/* Local utility functions */

/* Local Styled Components */

export default Impressum
